import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CtrlMenuHamIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M22 11H2C1.45 11 1 11.45 1 12C1 12.55 1.45 13 2 13H22C22.55 13 23 12.55 23 12C23 11.45 22.55 11 22 11Z"
        fill={color}
      />
      <path
        d="M22 20H2C1.45 20 1 20.45 1 21C1 21.55 1.45 22 2 22H22C22.55 22 23 21.55 23 21C23 20.45 22.55 20 22 20Z"
        fill={color}
      />
      <path
        d="M2 4H22C22.55 4 23 3.55 23 3C23 2.45 22.55 2 22 2H2C1.45 2 1 2.45 1 3C1 3.55 1.45 4 2 4Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

CtrlMenuHamIcon.displayName = 'CtrlMenuHamIcon';
